import { BsStarFill } from 'react-icons/bs';
import { H2, Hr } from 'src/components/_commons';
import { refreshUserReducer, setValuesAndOpenAlertModalReducer } from 'src/store';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { useGetCurrentUser, useGetIsDarkMode } from 'src/custom-hooks';
import { UserAssignmentsCarts } from './subcomponents/UserAssignmentsCarts';
import { UserAssignmentsHth } from './subcomponents/UserAssignmentsHth';
import { UserAssignmentsMechanics } from './subcomponents/UserAssignmentsMechanics';
import { UserAssignmentsMeetings } from './subcomponents/UserAssignmentsMeetings';
import { UserAssignmentsPublicMinistry } from './subcomponents/UserAssignmentsPublicMinistry';
import { UserAssignmentsTelephonic } from './subcomponents/UserAssignmentsTelephonic';
import { UserChangeEmail } from './subcomponents/UserChangeEmail';
import { UserChangePassword } from './subcomponents/UserChangePassword';
import { UserDeleteAccount } from './subcomponents/UserDeleteAccount';
import { UserLogoutAll } from './subcomponents/UserLogoutAll';
import { UserPasskeys } from './subcomponents/UserPasskeys';
import { UserPersonalData } from './subcomponents/UserPersonalData';
import { userServices } from 'src/services';

export const MyUserPage = () => {
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [showChangeEmail, setShowChangeEmail] = useState(false);
    const [showChangePsw, setShowChangePsw] = useState(false);
    const [showPasskeys, setShowPasskeys] = useState(false);
    const [showPersonalData, setShowPersonalData] = useState(false);
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();
    const user = useGetCurrentUser();

    const openAlertModalHandler = (title: string, message: string, animation?: number): void => {
        dispatch(setValuesAndOpenAlertModalReducer({
            mode: 'alert',
            title,
            message,
            animation
        }));
    }

    const openConfirmModalHandler = (title: string, message: string, execution: Function): void => {
        dispatch(setValuesAndOpenAlertModalReducer({
            mode: 'confirm',
            title,
            message,
            execution
        }));
    }

    useEffect(() => {
        userServices.GetUserByToken().then(response => {
            if (!response.user) {
                // dispatch(setResponse({ response }));
                return;
            }
            dispatch(refreshUserReducer(response.user));
        });
    }, [refreshCounter]);

    return (
        <>
        {showChangePsw &&
            <UserChangePassword
                closeModal={() => {
                    setShowChangePsw(false);
                    setRefreshCounter(x => x + 1);
                }}
                openAlertModalHandler={openAlertModalHandler}
                openConfirmModalHandler={openConfirmModalHandler}
            />
        }
        {showChangeEmail &&
            <UserChangeEmail
                closeModal={() => {
                    setShowChangeEmail(false);
                    setRefreshCounter(x => x + 1);
                }}
                openAlertModalHandler={openAlertModalHandler}
                openConfirmModalHandler={openConfirmModalHandler}
            />
        }
        {showPasskeys &&
            <UserPasskeys
                closeModal={() => {
                    setShowPasskeys(false);
                }}
                setRefreshCounter={setRefreshCounter}
            />
        }
        {showPersonalData &&
            <UserPersonalData
                closeModal={() => {
                    setShowPersonalData(false);
                    setRefreshCounter(x => x + 1);
                }}
            />
        }
        <H2 title={'MI USUARIO'} />
        <div className={`card text-center ${isDarkMode ? 'bg-dark text-white' : ''}`}
            style={{ margin: '30px auto', maxWidth: '700px', padding: '25px' }}
        >
            <h1 className={'my-2'}>
                {user.name} {user.lastName}
            </h1>
            <h3>
                {user.email}
            </h3>
            <Hr />
            <div className={'my-2'}>
                <h3>
                    Grupo de Predicación: {user.group ?? '(no cargado)'}
                </h3>
                {user.groupIsTheOverseer &&
                    <><BsStarFill className={'me-1'} style={{ marginBottom: '2px' }} />Superintendente del Grupo</>
                }
                {user.groupIsTheOverseer &&
                    <><BsStarFill className={'me-1'} style={{ marginBottom: '2px' }} />Auxiliar del Grupo</>
                }
            </div>
            <Hr />
            <div className={'my-2'}>
                <h3>
                    Roles en la aplicación:
                </h3>
                <h4>
                    {user.rolesAsText}
                </h4>
            </div>
            <Hr />
            <button className={'btn btn-general-blue fw-bold py-2 my-2'}
                onClick={() => setShowPersonalData(true)}
            >
                VER MIS DATOS EN LA APLICACIÓN
            </button>
            <button className={'btn btn-general-blue fw-bold py-2 my-2'}
                onClick={() => setShowPasskeys(true)}
            >
                VER Y CREAR LLAVES DE ACCESO
            </button>
            <button className={'btn btn-general-blue fw-bold py-2 my-2'}
                onClick={() => setShowChangePsw(true)}
            >
                CAMBIAR CONTRASEÑA
            </button>
            <button className={'btn btn-general-blue fw-bold py-2 my-2'}
                onClick={() => setShowChangeEmail(true)}
            >
                CAMBIAR DIRECCIÓN DE EMAIL / USERNAME
            </button>
            <UserLogoutAll
                refreshPage={() => setRefreshCounter(x => x + 1)}
            />
            <UserDeleteAccount />
            <Hr />
            <UserAssignmentsMeetings />
            <Hr />
            <UserAssignmentsMechanics />
            <Hr />
            <UserAssignmentsPublicMinistry />
            <Hr />
            <UserAssignmentsCarts />
            <Hr />
            <UserAssignmentsHth />
            <Hr />
            <UserAssignmentsTelephonic />
        </div>
        </>
    );
}
